import { render, staticRenderFns } from "./florence_ofuru_refKbox.vue?vue&type=template&id=f7e2dd5e&scoped=true&"
import script from "./florence_ofuru_refKbox.vue?vue&type=script&lang=js&"
export * from "./florence_ofuru_refKbox.vue?vue&type=script&lang=js&"
import style0 from "./florence_ofuru_refKbox.vue?vue&type=style&index=0&id=f7e2dd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e2dd5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
